export const PaymentGatewayNames = {
    VINDI: 'Vindi',
    PAGAR_ME: 'Pagar.me',
    MERCADO_PAGO: 'MercadoPago',
    PAGSEGURO: 'PagSeguro',
    CIELO: 'Cielo',
    BSPAG: 'Bspag',
};



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/enums/PaymentGatewayNames.ts